'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterOption {
  id: string;
  label: string;
  icon: string;
}

interface PracticeAreaFilterProps {
  options: FilterOption[];
  activeFilter: string;
  onFilterChange: (filterId: string) => void;
}

const PracticeAreaFilter: React.FC<PracticeAreaFilterProps> = ({
  options,
  activeFilter,
  onFilterChange,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-elevation-sm p-6 sticky top-24">
      <h3 className="text-xl font-serif font-semibold text-primary mb-4 flex items-center">
        <Icon name="FunnelIcon" size={24} className="text-accent mr-3" />
        Filter Practice Areas
      </h3>
      <div className="space-y-2">
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => onFilterChange(option.id)}
            className={`w-full flex items-center space-x-3 p-4 rounded-lg transition-all duration-300 ${
              activeFilter === option.id
                ? 'bg-gradient-to-r from-accent to-gold-dark text-primary shadow-subtle'
                : 'bg-surface text-text-primary hover:bg-accent/10'
            }`}
          >
            <Icon
              name={option.icon as any}
              size={24}
              className={activeFilter === option.id ? 'text-primary' : 'text-accent'}
            />
            <span className="font-medium">{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PracticeAreaFilter;